import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../app/theme";

export const useSaleBannerStyles = makeStyles((theme) => ({
  saleBanner: {
    fontFamily: fontFamily.Axiforma,
    color: "#fff",
    fontSize: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "18px"
    }
  },
  fontSizeSm: {
    fontSize: "10px !important"
  },
  colorOrange: {
    color: color.orange
  },
  timeBox: {
    fontFamily: fontFamily.Axiforma,
    backgroundColor: "#341561",
    borderRadius: "6px",
    minWidth: "30px",
    maxHeight: "29px",
    textAlign: "center",
    padding: "8px 5px 3px 6px",
    [theme.breakpoints.up("sm")]: {
      padding: "8px 11px 6px 12px",
      minWidth: "47px",
      maxHeight: "36px"
    }
  },
  separator: {
    marginLeft: "6px",
    marginRight: "6px"
  }
}));
